const SECTIONS: [string, string[]][] = [
  ["How IN/OUT texting works", [
    "When you arrive for a confirmed shift, text IN to the GamedayTime number. When you leave, text OUT.",
    "You'll get a reply with a one-time link. Open it and tap \"Share my location for this punch\". The link expires after a few minutes.",
    "Your official time is when your text was received, not when you tapped the link.",
  ]],
  ["The one-time location check", [
    "Your location is checked once, only when you tap the button, to confirm you're at the venue. We don't track you.",
    "Your coordinates are kept for timekeeping review (up to 3 years). You only ever see pass/fail and a rounded distance.",
  ]],
  ["Turning location back on", [
    "iPhone (Safari): Settings → Privacy & Security → Location Services → On, then Safari Websites → While Using. Or tap \"aA\" in the address bar → Website Settings → Location → Allow.",
    "Android (Chrome): tap the lock icon next to the address → Permissions → Location → Allow. Also check that Settings → Location is on.",
    "If you opened the link inside another app (like a messaging app's built-in browser), open it in Safari or Chrome instead.",
  ]],
  ["Indoor & stadium tips", [
    "Turn on Wi-Fi (you don't need to join a network). It improves accuracy indoors.",
    "Step near a concourse window, an opening or the gate for a few seconds, then tap Try again.",
    "Make sure \"Precise Location\" is on for your browser.",
  ]],
  ["When something fails", [
    "Your text time is saved, and an admin will review it. Tap \"Request Assistance / Correction\" on the link page, or use \"Request a correction\" on My Clock.",
    "If you forgot to text IN or OUT, send a correction request with the time you started or stopped.",
  ]],
  ["STOP & HELP", [
    "Reply HELP for help. Reply STOP to stop all texts from GamedayTime, and START to opt back in. While opted out, IN/OUT can't be processed.",
  ]],
];

export default function MyHelp() {
  return (
    <section data-testid="my-help-page" className="animate-rise max-w-3xl space-y-6">
      <div><p className="label-caps text-signal">Help</p><h1 className="font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl">Clocking in by text</h1><a href="/help" target="_blank" rel="noreferrer" className="mt-2 inline-block text-sm text-signal" data-testid="my-help-public-link">Full crew help page →</a></div>
      {SECTIONS.map(([title, items], i) => (
        <div key={title} data-testid={`my-help-section-${i}`} className="rounded-sm border border-white/10 bg-surface p-5">
          <h2 className="mb-2 font-display text-lg font-bold uppercase text-white">{title}</h2>
          <ul className="list-disc space-y-1.5 pl-5 text-sm text-zinc-300">{items.map((t) => <li key={t}>{t}</li>)}</ul>
        </div>
      ))}
    </section>
  );
}
